// Optional feedback only: unsupported/blocked browser APIs must never affect audio.
const pulses = { recording_start: 8, recording_lock: 16, recording_cancel: [10, 25, 10], recording_sent: 6 };
export function voiceHaptic(event, device = globalThis.navigator) {
  try {
    if (typeof device?.vibrate === "function" && pulses[event]) device.vibrate(pulses[event]);
  } catch (_) { /* Progressive enhancement: intentionally no error UI. */ }
}
